import { createSelector } from "reselect"
import { VIEW_TYPES } from "helpers/base"
import { getNextModeledDate } from "helpers/dates"
import { getUnmodeledDates } from "selectors/dates"
import { getLatestDate } from "modules/portfolio-root/selectors/dates"

export const getStartDate = (_, props) => props.startDate
export const getEndDate = (_, props) => props.endDate
const getBaseStartDate = (_, props) => props.baseStartDate
const getViewType = (_, props) => props.viewType

export const getPerformanceFetchStartDate = createSelector(
  [getStartDate, getBaseStartDate, getViewType, getUnmodeledDates, getLatestDate],
  (startDate, baseStartDate, viewType, unmodeledDates, latestDate) => {
    if (viewType === VIEW_TYPES.ACTIVE && baseStartDate && startDate <= baseStartDate) {
      return getNextModeledDate(baseStartDate, latestDate, unmodeledDates)
    }
    return startDate
  },
)
